
import Agent, { getType } from '../../types/agent';
import {ApiCall, NKTypeConvertor} from '../../fromKotlin/nk';

async function executeOrExplain(req: ApiCall) {
    try {
        return await req.execute();
    } catch (e) {
        const detail = req.lastError();
        if (detail) throw new Error(detail);
        if (e == null) throw new Error('הפעולה נכשלה');
        throw e;
    }
}

export const addNewAgent = async (a: Agent) => {
    const req = new ApiCall('NEW_AGENT');
    req.putParam('user_name', a.name);
    req.putParam('type', getType(a));
    if (a.phone?.trim()) req.putParam('phone', a.phone.trim());
    return req.execute();
};

export const addNewAgentForce = async (user_name: string, type: number, phone?: string) => {
    const req = new ApiCall('NEW_AGENT');
    req.putParam('user_name', user_name);
    req.putParam('type', type);
    if (phone?.trim()) req.putParam('phone', phone.trim());
    return req.execute();
};

/** Create a user from a spreadsheet row. Optional id is the internal user id. */
export const createImportedUser = async (input: { user_name: string; type: number; id?: number; phone?: string }) => {
    const req = new ApiCall('NEW_AGENT');
    req.putParam('user_name', input.user_name);
    req.putParam('type', input.type);
    if (input.id != null && input.id > 0) req.putParam('id', Math.trunc(input.id));
    if (input.phone?.trim()) req.putParam('phone', input.phone.trim());
    return executeOrExplain(req);
};

export const updateAgents = async (data, options?: { sendPassword?: boolean }) => {
    const req = new ApiCall('UPDATE_AGENT');
    const sendPassword = options?.sendPassword !== false;

    const ids = data.map((a) => a.id);
    const user_name = data.map((a) => a.name);
    const comment = data.map((a) => a.comment??'');
    const car = data.map((a) => (a.car ?? a.nkObject?.car ?? '') as string);
    const display_name = data.map((a) => (a.display_name ?? a.nkObject?.display_name ?? '') as string);
    const phone = data.map((a) => (a.phone ?? a.nkObject?.phone ?? '') as string);
    req.putParam('ids',NKTypeConvertor().toKotlinList(ids) );
    req.putParam('user_name',NKTypeConvertor().toKotlinList(user_name) );
    req.putParam('comment',NKTypeConvertor().toKotlinList(comment) );
    req.putParam('car', NKTypeConvertor().toKotlinList(car));
    req.putParam('display_name', NKTypeConvertor().toKotlinList(display_name));
    req.putParam('phone', NKTypeConvertor().toKotlinList(phone));
    // Omit password when the caller did not intend to change it. An empty password
    // list would clear the stored password.
    if (sendPassword) {
        const password = data.map((a) => (a.password ?? a.nkObject?.user_password ?? '') as string);
        req.putParam('password',NKTypeConvertor().toKotlinList(password) );
    }
    // Route-planner depots ("lat,lon"). Only sent when at least one row carries them so
    // the users table (which does not edit depots) never wipes existing values.
    if (data.some((a) => a.start_point !== undefined || a.end_point !== undefined)) {
        const start_point = data.map((a) => (a.start_point ?? a.nkObject?.start_point ?? '') as string);
        const end_point = data.map((a) => (a.end_point ?? a.nkObject?.end_point ?? '') as string);
        req.putParam('start_point', NKTypeConvertor().toKotlinList(start_point));
        req.putParam('end_point', NKTypeConvertor().toKotlinList(end_point));
    }
    return executeOrExplain(req);
};

/** Persist a driver's default start/end depot ("lat,lon" or '' to clear) for the route planner. */
export const updateAgentDepot = async (agent: Agent, kind: 'start' | 'end', value: string) => {
    const req = new ApiCall('UPDATE_AGENT');
    req.putParam('ids', NKTypeConvertor().toKotlinList([agent.id]));
    req.putParam(kind === 'start' ? 'start_point' : 'end_point', NKTypeConvertor().toKotlinList([value]));
    return req.execute();
};
